export default __webpack_public_path__ + "static/media/PPI-steps-011.0b59ee86.jpg";